/**
 * Auto-generated from theme.css - do not edit manually.
 * Regenerate by restarting the dev server or running a build.
 *
 * @see modules/SG/maisons/pia/resources/assets/css/theme.css
 */

export const themes = ['neutral-97', 'blue-80', 'blue-textured', 'white'] as const;

export type Theme = (typeof themes)[number];

const THEME_CLASS_PREFIX = 'phxsg-theme-' as const;

export function getThemeClass(theme: Theme) {
  return `${THEME_CLASS_PREFIX}${theme}`;
}
